// src/store/useTabStore.js
import { create } from "zustand";
import { arrayMove } from "@dnd-kit/sortable";

export const useTabStore = create((set, get) => ({
  tabs: [],
  activeTab: null,
  addTab: (tab) => {
    const exists = get().tabs.find((t) => t.id === tab.id);
    if (!exists) {
      set((state) => ({
        tabs: [...state.tabs, tab],
        activeTab: tab.id,
      }));
    } else {
      set({ activeTab: tab.id });
    }
  },
  removeTab: (id) => {
    set((state) => {
      const nextTabs = state.tabs.filter((t) => t.id !== id);
      const nextActive =
        state.activeTab === id ? nextTabs.at(-1)?.id ?? null : state.activeTab;
      return { tabs: nextTabs, activeTab: nextActive };
    });
  },
  setActiveTab: (id) => set({ activeTab: id }),
  clearTabs: () => set({ tabs: [], activeTab: null }),
  removeOtherTabs: (keepId) => {
    set((state) => {
      const keptTab = state.tabs.find((t) => t.id === keepId);
      return {
        tabs: keptTab ? [keptTab] : [],
        activeTab: keptTab ? keepId : null,
      };
    });
  },
  moveTab: (fromIndex, toIndex) =>
    set((state) => {
      // const moved = state.tabs.splice(fromIndex, 1)[0];
      // state.tabs.splice(toIndex, 0, moved);
      // return { tabs: state.tabs };
      const updated = arrayMove(state.tabs, fromIndex, toIndex);
      return { tabs: updated };
    }),
}));
